<template>
  <div class="home">
    <!-- アイキャッチ -->
    <v-img contain src="/img/index.jpg" />

    <!-- メインコンテンツ -->
    <v-container class="my-0" fluid>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          :md="gridSizeMoreThanMd"
          :lg="gridSizeMoreThanMd"
        >
          <!-- 商品一覧 -->
          <v-container class="my-0 py-0">
            <v-row>
              <!-- お知らせ通知 -->
              <template v-for="notice in notices">
                <v-col cols="12" :key="`notice${notice.id}`">
                  <v-card flat outlined>
                    <v-card-title class="py-3">
                      {{ notice.title }}
                    </v-card-title>
                    <v-card-text>
                      <pre v-html="notice.content"></pre>
                    </v-card-text>
                  </v-card>
                </v-col>
              </template>

              <!-- 直近の内容で再注文 -->
              <v-col
                v-if="latestOrder && latestOrder.status_id == STATUS_COMPLETE"
                cols="12"
              >
                <re-order
                  :latest-order="latestOrder"
                  @order-again-click="orderAgain"
                ></re-order>
              </v-col>

              <!-- 商品 -->
              <template v-if="items.length > 0">
                <v-col
                  class="merch-card-col"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="4"
                  v-for="item in items"
                  :key="item.id"
                >
                  <merch-card
                    :src="`/img/image${item.id}1.jpg`"
                    :text="item.display_name"
                    :for-sale="Number(item.inventory) > 0"
                    @card-click="selectItem(item.id)"
                  ></merch-card>
                </v-col>
              </template>

              <!-- スケルトンローダ -->
              <template v-else>
                <v-col cols="12" sm="6" md="6" lg="4" v-for="i in 3" :key="i">
                  <v-skeleton-loader
                    class="mx-auto"
                    type="card"
                  ></v-skeleton-loader>
                </v-col>
              </template>
            </v-row>
          </v-container>
        </v-col>
        <v-col
          v-if="historyEnabled"
          cols="12"
          sm="12"
          md="3"
          lg="3"
          class="py-6"
        >
          <!-- 注文履歴 -->
          <order-history
            :histories="histories"
            :status-order="STATUS_ORDER"
            :status-complete="STATUS_COMPLETE"
            @order-again-click="orderAgain"
            @order-cancel-click="cancelTargetSelected"
          ></order-history>

          <!-- 注文キャンセル確認ダイアログ -->
          <continue-dialog
            ref="coninueDialog"
            title="確認"
            continue-text="はい"
            continue-color="error"
            :execute-action="orderCancel"
          >
            <template v-if="cancelTarget">
              {{ cancelTarget.order_date }}
              の注文を取り消します。<br />よろしいですか？
            </template>
          </continue-dialog>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { OrderStatuses } from '../assets/komegura-config';
import ReOrder from '../components/ReOrder.vue';
import OrderHistory from '../components/OrderHistory.vue';
import ContinueDialog from '../components/ContinueDialog.vue';
import MerchCard from '../components/parts//MerchCard.vue';
import { Get } from '../assets/request-api.js';

export default {
  components: {
    ReOrder,
    OrderHistory,
    MerchCard,
    ContinueDialog,
  },
  data: () => ({
    cancelTarget: null,
    notices: null,
  }),
  computed: {
    ...mapGetters({
      // 認証ユーザー
      authUser: 'auth/authUser',
      // 商品一覧
      items: 'merchandise/itemLists',
      findDetail: 'merchandise/findDetail',
      // 注文履歴
      histories: 'auth/orderHistories',
      // 最新の注文履歴
      latestOrder: 'auth/latestOrder',
    }),
    STATUS_ORDER: () => OrderStatuses.ORDER,
    STATUS_COMPLETE: () => OrderStatuses.COMPLETE,
    // 注文履歴表示有無
    historyEnabled() {
      // return this.authUser && (this.latestOrder && (this.latestOrder.status_id!=this.STATUS_COMPLETE))
      return this.authUser;
    },
    // mdサイズ以上の時のグリッドサイズ指定
    gridSizeMoreThanMd() {
      return this.historyEnabled ? 9 : 12;
    },
  },
  methods: {
    // 商品選択
    async selectItem(id) {
      this.$router.push(`/merch?id=${id}`);
    },
    // 注文履歴取得
    getOrderHistories() {
      if (this.authUser) {
        this.$store.dispatch('auth/loadOrderHistories');
      }
    },
    // キャンセル対象選択
    cancelTargetSelected(history) {
      this.cancelTarget = history;
      this.$refs.coninueDialog.open();
    },
    // 注文キャンセル
    async orderCancel() {
      this.$store
        .dispatch('auth/orderCancel', this.cancelTarget.id)
        .catch(e => {
          this.$store.dispatch('auth/loadOrderHistories');
          alert(e);
        })
        .finally(() => {
          this.cancelTarget = null;
        });
    },
    // 以前と同じ内容で注文
    async orderAgain(details) {
      await this.$store.dispatch('cart/clearCart');

      details.forEach(async element => {
        //  console.log( this.$store.getters.findDetail(element.merchandise_id))
        // console.log(this.$store.getters['merchandise/itemDetails']);

        await this.$store.dispatch('merchandise/loadItemDetailByKey', {
          id: element.merchandise_id,
          priceTypeId: element.price_type_id,
        });

        const item = this.$store.getters['merchandise/findDetail'](
          element.merchandise_id
        );

        const type = item.types.find(
          el =>
            el.merchandise_id == element.merchandise_id &&
            el.price_type_id == element.price_type_id &&
            el.size == element.size
        );

        if (item && type) {
          await this.$store.dispatch('cart/addItem', {
            merchandiseId: element.merchandise_id,
            priceTypeId: element.price_type_id,
            size: element.size,
            packingId: 0,
            price: type.price,
            qty: Number(element.qty),
            amount: type.price * Number(element.qty),
            merchandiseName: item.display_name,
            typeName: type.name,
            image: element.image_url_1,
          });
        }

        // console.log(price);
      });

      this.$router.push('/order').catch(() => {});
    },
  },
  async created() {
    // ストアに商品一覧が格納されていなければ取得
    if (this.items.length == 0) {
      this.$store.dispatch('merchandise/loadItemLists');
    }
    // ストアに履歴が格納されていなければ取得
    if (!this.histories) {
      this.getOrderHistories();
    }

    const result = await Get('notices');

    if (RegExp(/^2[0-9]{2}$/u).test(result.statusCode)) {
      this.notices = result.response;
    }
  },
  watch: {
    authUser: function() {
      this.getOrderHistories();
    },
  },
};
</script>

<style>
pre {
  white-space: pre-wrap;
}
.merch-card-col {
  display: flex;
}
</style>
